import { connect } from 'react-redux'
import toJS from './general/toJS'
import Sidebar from '../components/Sidebar';
import React from 'react'
import hasPrintSubmenu from '../functions/hasPrintSubmenu';
import { AUTH } from '../constants/state';

const mapStateToProps = state => ({
    cinemaName: state.getIn(['wpServerData', 'data', 'data', 'site', 'name']),
    webToPrintRoutes: state.getIn(['wpServerData', 'data', 'data', 'webtoprint']),
    routeData: state.getIn(['wpServerData', 'data', 'data', 'routes']),
    caps: state.getIn([AUTH, 'caps'])
})

class SidebarContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCopyright: false
        }

        this.onCopyrightClick = this.onCopyrightClick.bind(this)
    }

    onCopyrightClick() {
        this.setState({
            showCopyright: !this.state.showCopyright
        })
    }

    render() {
        let usedRoutes = []
   
        const {showCopyright} = this.state
        const {cinemaName, webToPrintRoutes, routeData, caps} = this.props

        if(routeData) {
            if(caps.hasOwnProperty('eventDataGet') && !caps.eventDataGet && routeData.hasOwnProperty('events')) {
                routeData.events = false
            }

            if(caps.hasOwnProperty('pushDataGet') && !caps.pushDataGet && routeData.hasOwnProperty('apps')) {
                routeData.apps = false
            }

            if(caps.hasOwnProperty('programDataSee') && !caps.programDataSee && routeData.hasOwnProperty('program')) {
                if(routeData.hasOwnProperty('program')) {
                    routeData.program = false
                }
                
                if(routeData.hasOwnProperty('movies')) {
                    routeData.movies = false
                }
                
                if(routeData.hasOwnProperty('weischer')) {
                    routeData.weischer = false
                }
                
                if(routeData.hasOwnProperty('elbenwald')) {
                    routeData.elbenwald = false
                }
                
                if(routeData.hasOwnProperty('advertisement')) {
                    routeData.advertisement = false
                }
                
                if(routeData.hasOwnProperty('website')) {
                    routeData.website = false
                }
            }

            if(caps.hasOwnProperty('signageDataGet') && !caps.signageDataGet && (routeData.hasOwnProperty('signagelite') || routeData.hasOwnProperty('signage'))) {
                routeData.signagelite = false
                routeData.signage = false
            }

            if(caps.hasOwnProperty('cinemaDataSee') && !caps.cinemaDataSee && routeData.hasOwnProperty('cinemas')) {
                routeData.cinemas = false
            }
            
            _.keys(routeData).map((route) => {
                if(routeData[route] === 'true' || routeData[route] === true) {
                    usedRoutes.push(route)
                }
            })
                
            if(routeData.program || routeData.website || routeData.movies) {
                usedRoutes = _.without(usedRoutes, 'program', 'weischer',  'movies')
            }

            if(!routeData.website && routeData.program && routeData.weischer) {
                usedRoutes.splice(1, 0, 'website')
            }
            
            if(hasPrintSubmenu(webToPrintRoutes, routeData)) {
                usedRoutes = _.without(usedRoutes, 'webtoprint')
                usedRoutes.push('marketing')
            }
        }

        return <Sidebar cinemaName={cinemaName}
                        showCopyright={showCopyright}
                        usedRoutes={usedRoutes}
                        onClick={this.onCopyrightClick} />
    }
}


export default connect(mapStateToProps)(toJS(SidebarContainer))